<script setup lang="ts">
import { computed } from 'vue'
import { ORDER_STATUS } from '@/constants/orderStatus'
import { DEROGATION_STATUS } from '@/constants/derogationStatus'
import { ARBITRATION_STATUS } from '@/constants/arbitrationStatus'
import { LEAD_STATUS } from '@/constants/LeadStatus';

defineEmits<{ (e: 'click'): void }>()

const props = defineProps({
  statusCounts: {
    type: Object as () => Record<string, { count: number; sumMarge: number }>,
    required: true,
  },
  counter: {
    type: Object as () => {
      value: string
      label: string
    },
    required: true,
  },
  statusType: {
    type: String as () => 'order' | 'derogation' | 'arbitration' | 'lead',
    default: 'order',
  },
})

const count = computed(() => props.statusCounts[props.counter.value]?.count || 0)
const sumMarge = computed(() => props.statusCounts[props.counter.value]?.sumMarge || 0)
</script>

<template>
  <div
    role="button"
    tabindex="0"
    class="cursor-pointer transition-opacity hover:opacity-90 overflow-visible"
    @click="$emit('click')"
    @keydown.enter="$emit('click')"
    :class="{
      'card shadow flex-column justify-between': true,
      'bg-neutral-100': (statusType === 'order' && counter.value === ORDER_STATUS.DRAFT) || (statusType === 'lead' && counter.value === LEAD_STATUS.WAITING),
      'bg-blue-100': (statusType === 'order' && counter.value === ORDER_STATUS.WAITING) || (statusType === 'derogation' && counter.value === DEROGATION_STATUS.PENDING) || (statusType === 'arbitration' && counter.value === ARBITRATION_STATUS.PENDING) || (statusType === 'lead' && counter.value === LEAD_STATUS.ACCEPTED),
      'bg-emerald-100': (statusType === 'order' && counter.value === ORDER_STATUS.VALIDATED) || (statusType === 'derogation' && counter.value === DEROGATION_STATUS.APPROVED) || (statusType === 'arbitration' && counter.value === ARBITRATION_STATUS.APPROVED) || (statusType === 'lead' && (counter.value === LEAD_STATUS.WON)),
      'bg-orange-100': statusType === 'order' && (counter.value === ORDER_STATUS.BLOCKED_BUSINESS || counter.value === ORDER_STATUS.BLOCKED_OPERATOR),
      'bg-red-100': (statusType === 'order' && counter.value === ORDER_STATUS.CANCELED) || (statusType === 'derogation' && counter.value === DEROGATION_STATUS.REJECTED) || (statusType === 'arbitration' && counter.value === ARBITRATION_STATUS.REJECTED) || (statusType === 'lead' && (counter.value === LEAD_STATUS.LOST || counter.value === LEAD_STATUS.REFUSED)),
      'bg-indigo-100': statusType === 'order' && counter.value === ORDER_STATUS.IN_PROGRESS,
      'bg-[#DA70D6]/20': statusType === 'order' && counter.value === ORDER_STATUS.SENT_TO_BU_MANAGER,
    }"
  >
    <div class="card-body p-4 flex-column justify-around items-center gap-4">
      <h2 class="card-title text-sm opacity-70 uppercase text-center">{{ counter.label }}</h2>
      <div class="flex-column text-center items-center">
        <p class="text-3xl font-bold grow-0">{{ count }}</p>
        <p v-if="sumMarge > 0" class="text-xs opacity-60 font-medium">
          Marge: {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(sumMarge) }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
